import { tv } from "tailwind-variants";

import { monsterrat } from "@/services/styles/fonts";

export const getArticleCardClass = tv({
  base: ["flex max-w-[420px] flex-col", "select-none rounded-2xl bg-white", "shadow-[0_0_32px_4px_rgba(0,90,217,0.1)]"],
});

export const getCoverImageClass = tv({
  base: ["h-60 w-full rounded-t-2xl object-cover"],
});

export const getTitleClass = tv({
  base: [monsterrat.className, "mt-2 font-semibold text-primary-900 text-sm lg:text-base"],
});

export const getDescriptionClass = tv({ base: ["mt-4 flex-1 text-primary-900 text-sm lg:mt-8 lg:text-base"] });

export const getFooterMetaClass = tv({
  base: ["pointer-events-none flex items-center gap-1 font-semibold text-gray-500 text-sm lg:text-base"],
});
